export default __webpack_public_path__ + "static/media/silhouette_city.9e8b7a07.svg";